import { createSlice } from "@reduxjs/toolkit";
import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";

export { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";

const createInitialDocumentUploadState = () => ({
  documents: [],
  docTypes: [],
});

export const INITIAL_STATE = Object.fromEntries(
  Object.values(UPLOAD_ENTITY_TYPES).map((entityType) => [
    entityType,
    createInitialDocumentUploadState(),
  ])
);

const documentUploadsSlice = createSlice({
  name: "documentUploads",
  initialState: INITIAL_STATE,
  reducers: {
    setDocuments: (state, action) => {
      const { documents, entityType } = action.payload;
      state[entityType].documents = documents;
    },
    updateDocumentType: (state, action) => {
      const { id, type, entityType } = action.payload;
      state[entityType].documents = state[entityType].documents.map(
        (document) => {
          if (document.id === id) {
            return {
              ...document,
              type,
            };
          }
          return document;
        }
      );
    },
    removeDocument: (state, action) => {
      const { id, entityType } = action.payload;
      state[entityType].documents = state[entityType].documents.filter(
        (document) => document.id !== id
      );
    },
    setDocTypes: (state, action) => {
      const { docTypes, entityType } = action.payload;
      state[entityType].docTypes = docTypes;
    },
  },
});

export const {
  setIsLoading,
  setDocuments,
  updateDocumentType,
  removeDocument,
  setDocTypes,
} = documentUploadsSlice.actions;

export default documentUploadsSlice.reducer;
